


















































































import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { EventPostStatus } from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import { AuthorisedOnly } from "@/lib/decorators";
import emitter from "@/lib/emitter";
import { isMediaFile } from "@/lib/fileHelpers";
import { getLiveUrl } from "@/lib/urlHelpers";
import router from "@/router";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import { ProcessedContentFiles } from "@/components/ContentFeedItem";
import ContentFeedBaseView from "@/components/ContentFeedItem/components/ContentFeedBaseView";
import ContentFeedEventTicket from "@/components/ContentFeedItem/components/ContentFeedEventTicket";
import ContentFeedFileList from "@/components/ContentFeedItem/components/ContentFeedFileList";
import ContentFeedGallery from "@/components/ContentFeedItem/components/ContentFeedGallery";
import EventTicketPurchaseModal from "@/components/EventTicketPurchaseModal";
import FormatMoney from "@/components/FormatMoney";
import FeedItemMixin from "../../mixins/FeedItemMixin";

@Component({
  name: "EventView",
  components: {
    EventTicketPurchaseModal,
    BaseIcon,
    BaseButton,
    ContentFeedBaseView,
    ContentFeedFileList,
    ContentFeedGallery,
    ContentFeedEventTicket,
    BaseConfirm,
    FormatMoney,
  },
})
export default class EventView extends mixins(WithAuthUser, FeedItemMixin) {
  @Prop({ type: Object, required: true })
  public readonly contentFeed!: ContentFeed;

  @Prop({ type: Array, required: true })
  public readonly subscriptionLevels!: SubscriptionLevel[];

  @Prop({ type: Array, required: true })
  public readonly paymentPackages!: PaymentPackage[];

  @Prop({ type: Boolean, default: false })
  public readonly showFollowButton!: boolean;

  @Prop({ type: Boolean, default: true })
  public readonly showReportItem!: boolean;

  @Prop({ type: Boolean, default: true })
  public readonly showComment!: boolean;

  @Prop({ type: Boolean, default: true })
  public readonly showFooter!: boolean;

  @AuthorisedOnly
  public unlockFeed() {
    emitter.emit(EVENTS.CONTENT_FEED_PURCHASE, this.contentFeed);
  }

  public showPurchaseModal: boolean = false;

  public isTicketBooked: boolean = false;

  public get processedFiles() {
    return this.contentFeed.files.reduce<{ documents: ProcessedContentFiles; media: ProcessedContentFiles }>(
      (out, f) => {
        const key = isMediaFile(f) ? "media" : "documents";
        const accessKey = this.hasAccessToFile(f) ? "accessed" : "locked";
        out[key].all.push(f);
        out[key][accessKey].push(f);
        return out;
      },
      {
        documents: { locked: [], accessed: [], all: [] },
        media: { locked: [], accessed: [], all: [] },
      }
    );
  }

  public get isMyEvent() {
    return this.authUser && this.authUser.id === this.contentFeed.userId;
  }

  public get ticketsBooked() {
    return this.contentFeed.details?.event.ticketsBooked || 0;
  }

  public hasAccessToFile(f: ContentFile) {
    return this.isMyEvent || this.contentFeed.purchased || f.publicAccess;
  }

  public onBookTicketClick() {
    this.showPurchaseModal = true;
  }

  public get showBookBlock() {
    return (
      this.contentFeed.details?.event.minimumLevelId !== "0" ||
      this.contentFeed.details?.event.ticketPricePackageId !== "0"
    );
  }

  public get liveUrl() {
    return getLiveUrl(this.authUserStrict);
  }

  public get showStartBtn() {
    return (
      (this.contentFeed.details?.event?.status === EventPostStatus.READY_TO_START ||
        this.contentFeed.details?.event?.status === EventPostStatus.STARTED) &&
      this.isMyEvent
    );
  }

  public get showBookedBtn() {
    return this.contentFeed.details?.event?.status === EventPostStatus.PUBLISHED && this.isMyEvent;
  }

  public get showTicketBookedBtn() {
    return (
      (this.contentFeed.details?.event?.status === EventPostStatus.PUBLISHED ||
        this.contentFeed.details?.event?.status === EventPostStatus.READY_TO_START ||
        this.contentFeed.details?.event?.status === EventPostStatus.STARTED) &&
      this.showBookBlock &&
      !this.isMyEvent
    );
  }

  public get showEndedText() {
    return this.contentFeed.details?.event?.status === EventPostStatus.ENDED;
  }

  public get showCancelledText() {
    return this.contentFeed.details?.event?.status === EventPostStatus.CANCELLED;
  }

  public goLive() {
    router.push(this.liveUrl);
  }

  public finishBooking() {
    this.showPurchaseModal = false;
    this.isTicketBooked = true;
  }

  public mounted() {
    this.isTicketBooked = this.contentFeed.details?.event.availableByTicket;
  }
}
